import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import './styles/Balance.scss'

import FilterUser from './components/FilterUser'
import Collaborator from './components/Collaborator'

import NewBalance from './components/NewBalance'
import BalanceList from './components/BalanceList'

import { getUser } from 'panel/user/redux/actions'
import { maskDate, maskMoney } from 'util/masks'
import { getBalance, getPaymentList } from './redux/actions'
import { ApplicationState } from 'AppReducer'

const startDate = new Date((new Date()).setDate((new Date()).getDate() - 7))
const start = startDate.toLocaleDateString('pt-BR')
const end = (new Date()).toLocaleDateString('pt-BR')

type FilterType = { start: string, end: string }

const Balance: React.FC = () => {
  const dispatch = useDispatch()

  const [filter, setFilter] = useState<FilterType>({ start, end })

  const { id } = useParams<{ id?: string }>()
  const { user } = useSelector((state: ApplicationState) => state.userReducer)
  const { balance } = useSelector((state: ApplicationState) => state.balanceReducer)

  function handleDateFormat (filter: FilterType): FilterType {
    return {
      start: filter.start.split('/').reverse().join('-'),
      end: filter.end.split('/').reverse().join('-')
    }
  }

  function handleSubmit (e?: React.FormEvent): void {
    e?.preventDefault()
    if (id) {
      getPaymentList(id, handleDateFormat(filter))(dispatch)
    }
  }

  useEffect(() => {
    if (id) {
      getUser(id)(dispatch)
      getBalance(id)(dispatch)
      getPaymentList(id, handleDateFormat(filter))(dispatch)
    }
    // eslint-disable-next-line
  }, [id])

  return (
    <div className="row balance-property">
      <FilterUser />

      {
        user &&
        <div className="row">
          <Collaborator user={user} />
          <NewBalance onCreate={handleSubmit} />

          <div className="row margin-top-16 align-end box-filter">
            <div className="row" style={{ width: 300 }}>
              <p>Saldo</p>
              <h1>{ maskMoney(balance || 0) }</h1>
            </div>
            <div className="grow align-end">
              <form className="row justify-end align-end" onSubmit={handleSubmit}>
                <div className="form-control" style={{ width: 200 }}>
                  <p>De</p>
                  <input
                    required
                    type="text"
                    value={filter.start}
                    onChange={(e): void => setFilter({ ...filter, start: maskDate(e.target.value, '/') })}
                  />
                </div>
                <div className="form-control" style={{ width: 200 }}>
                  <p>Até</p>
                  <input
                    required
                    type="text"
                    value={filter.end}
                    onChange={(e): void => setFilter({ ...filter, end: maskDate(e.target.value, '/') })}
                  />
                </div>
                <button className="primary align-center"><i className="fa fa-filter" /> Filtrar</button>
              </form>
            </div>
          </div>

          <BalanceList />
        </div>
      }
    </div>
  )
}

export default Balance
